//import {setUrl} from './util';
import edgePng from '../img/edge.png';
import chromePng from '../img/chrome.png';
import playncPng from '../img/plaync.png';

export function setTemplate(data){
	const target = document.getElementById('app');
	const title = document.getElementsByTagName('title')[0];

	target.innerHTML = `
	<div class="wrap-support-browser-guide">
		<header>
			<h1><a class="logo" href="https://www.plaync.com?visitedIeNotice1=true"><img src="${playncPng}" alt="plaync icon"/></a></h1>
		</header>
		<section class="contents">
			<h2 class="title">${data.support.text.notice_title}</h2>
			<p class="notice">${data.support.text.notice_content}</p>
			<div class="link-area">
				<a class="chrome" href="https://www.google.com/chrome/" target="_blank">
					<span class="wrap-img"><img src="${chromePng}" alt="chrome icon"/></span>
				</a>
				<a class="edge" href="javascript:;" onclick="window.location = 'microsoft-edge:' + document.referrer;">
					<span class="wrap-img"><img src="${edgePng}" alt="edge icon"/></span>
				</a>
			</div>			
		</section>
		<footer><p>&copy; NCSOFT Corporation. All Rights Reserved.</p></footer>
	</div>

	`;
	// 브라우저 타이틀 내용
	title.innerHTML = `
		${data.support.text.notice_title}
	`;

	// href 속성 값을 변경
	//setUrl(data);



}
